export default __webpack_public_path__ + "static/media/heroimg.d65bf233.png";